export async function rolesDropdownIndexUseCase(is_for_clients, rolRepository) {
    const result = await rolRepository.dropdown_index(is_for_clients);

    result.data.success.arguments.forEach(x => {

        x = new rolRepository.model_index(x);

        if (!x.isValid()) {
            throw new Error("rol inválido");
        }
    })

    return result.data.success.arguments;
}